import { Toaster } from "react-hot-toast";
import Layout from "./shared/Layout";
import { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { API_URL, baseurl } from "../_config";

const PlayerList = () => {
    const navigate = useNavigate();
    const [error, setError] = useState();
    const [userList, setUserList] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);

    const fetchuserList = async () => {
        try {
            const response = await axios.get(`${baseurl}${API_URL.getPlayerDetail}`);
            if (response?.data?.isSuccess === 1) {
                setUserList(response?.data?.data)
            }
        } catch (error) {
            return null;
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchuserList();
    }, []);

    useEffect(() => {
        if (searchTerm) {
            const filtered = userList?.filter(item =>
                (item.firstName && item.firstName.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.emailId && item.emailId.toString().includes(searchTerm.toString())) ||
                (item.contactNumber && item.contactNumber.toString().includes(searchTerm.toString()))
            );
            setFilteredData(filtered);
        } else {
            setFilteredData(userList);
        }
    }, [searchTerm, userList]);

    const columns = [
        {
            name: 'S.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '60px',
        },
        {
            name: 'Name',
            selector: row => (
                <div>{row.firstName}{row.lastName}</div>
            ),
            sortable: true,
            minWidth: '200px'
        },
        {
            name: 'Email Id',
            selector: row => (
                <div className="" >
                    <h6>{row.emailId}</h6>
                    <span>{row?.contactNumber}</span>
                </div>
            ),
            sortable: true,
            minWidth: '250px'
        },
        {
            name: 'DOB',
            selector: row => {
                if (row.dob) {
                    const date = new Date(row.dob);
                    const indianTime = new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
                    const day = String(indianTime.getDate()).padStart(2, '0');
                    const month = String(indianTime.getMonth() + 1).padStart(2, '0');
                    const year = indianTime.getFullYear();

                    return `${day}/${month}/${year}`;
                } else {
                    return 'N/A';
                }
            },
            sortable: false,
            minWidth: '180px'
        },
        {
            name: 'Gender',
            selector: row => row.gender,
            sortable: false,
            minWidth: '120px'

        },
        {
            name: 'Age',
            selector: row => row.age,
            sortable: false,
            minWidth: '120px'

        },
        {
            name: 'EmergencyDetails',
            selector: row => (
                <div className="" >
                    <h6>{row.emergencyName}</h6>
                    <span>{row?.emergencyNumber}</span>
                </div>
            ),
            sortable: true,
            minWidth: '250px'
        },
        {
            name: 'category',
            selector: row => row.category,
            sortable: false,
            minWidth: '120px'

        },
        {
            name: 'Achievements',
            selector: row => row.achievements,
            sortable: false,
            minWidth: '120px'

        },
        {
            name: 'academy',
            selector: row => row.academy,
            sortable: false,
            minWidth: '120px'

        },
        {
            name: 'ranking',
            selector: row => row.ranking,
            sortable: false,
            minWidth: '120px'

        },
        {
            name: 'City',
            selector: row => row.city,
            sortable: false,
            minWidth: '120px'

        },
        {
            name: 'State',
            selector: row => row.state,
            sortable: false,
            minWidth: '120px'

        },
        {
            name: 'pincode',
            selector: row => row.pincode,
            sortable: false,
            minWidth: '120px'
        }
    ];

    return (
        <Layout>
            <Toaster position="top-right" />
            <div className="right-content-section">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading" style={{ gap: "20px" }}>
                        <h4 className="mb-0">Players List</h4>
                    </div>
                    <div className="d-md-flex align-items-center justify-content-end" style={{ gap: "20px" }}>
                        <div className="search-container ">
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>
                {error ? (
                    <p>Data not avaiable</p>
                ) : (
                    <div className="datatable mt-4">
                        <DataTable
                            columns={columns}
                            data={filteredData || []}
                            progressPending={loading}
                            progressComponent={<p>Loading...</p>}
                            pagination
                            highlightOnHover
                        />
                    </div>
                )}
            </div>
        </Layout>
    )
}

export default PlayerList;